<template>
  <div
    class="sideBG z-30 h-full min-h-screen"
    style="width: 5.2rem;"
  >
    <div
      class="flex h-16 w-full items-center justify-center border-b border-secondary-400"
    >
      <div v-if="$isStandard">
        <div class="flex">
          <div class="h-3 w-3" />
          <div class="h-3 w-3 bg-green-600 shadow" />
          <div class="h-3 w-3" />
        </div>
        <div class="flex">
          <div class="h-3 w-3 bg-green-600 shadow" />
          <div class="h-3 w-3 bg-green-100 shadow" />
          <div class="h-3 w-3 bg-green-700 shadow" />
        </div>
        <div class="flex">
          <div class="h-3 w-3" />
          <div class="h-3 w-3 bg-green-700 shadow" />
          <div class="h-3 w-3" />
        </div>
      </div>
      <img
        v-if="$isNine"
        class="mx-auto h-14"
        :src="currentTheme.logoSmall"
      >
    </div>

    <div
      class="flex h-full flex-col justify-start border-r border-secondary-400 pt-2 shadow-inner"
    >
      <div v-if="isAuthenticated">
        <div class="relative">
          <div
            v-if="forename !== '' && surname !== ''"
            id="myProfileSidebar"
            class="flex items-center justify-center p-4 text-center"
            @mouseover="isHoveringUserInfo = true; hideTour()"
            @mouseleave="isHoveringUserInfo = false; showTour()"
          >
            <div class=" group -mb-2 cursor-pointer flex-row">
              <div
                class="mx-auto flex h-7 w-7 cursor-pointer select-none items-center justify-center rounded-full bg-gradient-to-br from-white to-gray-200 text-center text-xs leading-none text-secondary-500 transition-all"
              >
                <span>
                  {{ forename.charAt(0) }}{{ surname.charAt(0) }}
                </span>
              </div>
              <div class="transition-150 brand-heading mt-2 block w-full select-none text-sm text-gray-400  transition-color group-hover:text-white">
                Points
              </div>
            </div>
          </div>
          <MenuTooltip
            class="mt-3"
            :is-hovering="isHoveringUserInfo"
            arrow-position="top"
            :tooltip-width="'w-72'"
          >
            <div
              class="flex w-full bg-white"
            >
              <router-link
                :to="shouldBeMigratedToNine ? '' : '/points/'"
                class="flex items-center justify-center border-r border-gray-100 p-4"
                :class="lessonsEnabled ? 'w-1/3' : 'w-1/2'"
              >
                <div
                  class="mr-2 leading-none"
                  style="font-size: 1.425rem;"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="home"
                    class="text-gray-700"
                    style="height: 1.7rem; width: 1.7rem;"
                    role="img"
                    viewBox="0 0 576 512"
                  ><g class="fa-group"><path
                    class="fa-secondary"
                    fill="currentColor"
                    d="M336 463.59V368a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v95.71a16 16 0 0 1-15.92 16L112 480a16 16 0 0 1-16-16V300.06l184.39-151.85a12.19 12.19 0 0 1 15.3 0L480 300v164a16 16 0 0 1-16 16l-112-.31a16 16 0 0 1-16-16.1z"
                    opacity="0.4"
                  /><path
                    class="fa-primary"
                    fill="currentColor"
                    d="M573.32 268.35l-25.5 31a12 12 0 0 1-16.9 1.65L295.69 107.21a12.19 12.19 0 0 0-15.3 0L45.17 301a12 12 0 0 1-16.89-1.65l-25.5-31a12 12 0 0 1 1.61-16.89L257.49 43a48 48 0 0 1 61 0L408 116.61V44a12 12 0 0 1 12-12h56a12 12 0 0 1 12 12v138.51l83.6 68.91a12 12 0 0 1 1.72 16.93z"
                  /></g></svg>
                </div>
                <div>
                  <div class="text-sm font-semibold leading-none text-gray-800">
                    {{ homePoints }}
                  </div>
                  <div class="text-xs uppercase leading-none text-gray-800">
                    Home
                  </div>
                </div>
              </router-link>
              <router-link
                :to="shouldBeMigratedToNine ? '' :'/points/flexi'"
                class="flex items-center justify-center p-4"
                :class="lessonsEnabled ? 'w-1/3 border-r border-gray-100' : 'w-1/2'"
              >
                <div
                  class="mr-2 leading-none"
                  style="font-size: 1.55rem;"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="random"
                    class="text-gray-700"
                    style="height: 1.6rem; width: 1.6rem;"
                    role="img"
                    viewBox="0 0 512 512"
                  ><g class="fa-group"><path
                    class="fa-secondary"
                    fill="currentColor"
                    d="M505 359l-80-80c-15-15-41-4.47-41 17v40h-32l-52.78-56.55-53.33 57.14 70.55 75.6a12 12 0 0 0 8.77 3.81H384v40c0 21.46 26 32 41 17l80-80a24 24 0 0 0 0-34zM122.79 96H12a12 12 0 0 0-12 12v56a12 12 0 0 0 12 12h84l52.78 56.55 53.33-57.14-70.55-75.6a12 12 0 0 0-8.77-3.81z"
                    opacity="0.4"
                  /><path
                    class="fa-primary"
                    fill="currentColor"
                    d="M505 119a24 24 0 0 1 0 34l-80 80c-15 15-41 4.48-41-17v-40h-32L131.56 412.19a12 12 0 0 1-8.77 3.81H12a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h84L316.44 99.81a12 12 0 0 1 8.78-3.81H384V56c0-21.44 25.94-32 41-17z"
                  /></g></svg>
                </div>
                <div>
                  <div class="text-sm font-semibold leading-none text-gray-800">
                    {{ flexiPoints }}
                  </div>
                  <div class="text-xs uppercase leading-none text-gray-800">
                    Flexi
                  </div>
                </div>
              </router-link>
              <div
                v-if="lessonsEnabled"
                class="flex w-1/3 items-center justify-center p-4"
              >
                <div
                  class="mr-2 leading-none"
                  style="font-size: 1.425rem;"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    class="text-gray-700"
                    style="height: 1.6rem; width: 1.6rem;"
                    role="img"
                    viewBox="0 0 640 512"
                  ><g class="fa-group"><path
                    class="fa-secondary"
                    fill="currentColor"
                    d="M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 40.36 0 47.59l58.03 17.84c-8.81 13.39-14.41 28.83-16.2 45.21C24.15 272.72 0 301.23 0 336c0 30.59 19.87 56.33 47.39 65.44L33.03 487.1c-1.49 7.06 3.84 13.9 11.06 13.9h71.8c7.23 0 12.56-6.84 11.07-13.9L112.6 401.44C140.13 392.33 160 366.59 160 336c0-26.17-16.08-48.33-38.72-57.86 2.34-11.14 7.79-21.2 15.53-29.04l159.57 49.02c15.2 4.67 31.6 4.67 46.79 0l278.94-85.7c23.55-7.24 23.55-40.37 0-47.6z"
                    opacity="0.4"
                  /><path
                    class="fa-primary"
                    fill="currentColor"
                    d="M536.17 249.1l-178.98 55c-15.2 4.67-31.6 4.67-46.79 0l-131.59-40.43c-17.53 17.45-28.4 40.56-30.28 65.67C176.34 341.83 192 369.68 192 400v16c0 26.51 21.49 48 48 48h160c26.51 0 48-21.49 48-48v-16c0-30.32 15.66-58.17 43.53-70.66-1.88-25.11-12.75-48.22-30.28-65.67L536.17 249.1c11.69-3.59 20.37-12.29 23.83-22.69v87.59c0 8.84 7.16 16 16 16s16-7.16 16-16V226.41c-3.46 10.4-12.14 19.1-23.83 22.69z"
                  /></g></svg>
                </div>
                <div>
                  <div class="text-sm font-semibold leading-none text-gray-800">
                    {{ lessonPoints }}
                  </div>
                  <div class="text-xs uppercase leading-none text-gray-800">
                    Lessons
                  </div>
                </div>
              </div>
            </div>
            <div class="flex items-center justify-center bg-gradient-to-br from-secondary-400 to-secondary-600 text-center text-white">
              <div class="w-full min-w-full">
                <div
                  v-if="!isExpired && isAuthenticated"
                  class="w-full min-w-full p-6 text-center text-sm uppercase text-white"
                  :class="expiringSoon ? 'bg-yellow-300' : ' bg-gradient-to-br from-brand-200 to-brand-500'"
                >
                  <div class="text-xxs mb-1 font-normal leading-none">
                    Membership expires
                  </div>
                  <div class="brand-heading leading-none">
                    {{ $moment(membershipExpires).format('dddd, Do MMMM YYYY') }}
                  </div>
                </div>

                <div
                  v-if="isExpired"
                  class="bg-red-600 p-6 text-center text-sm font-semibold uppercase text-white"
                >
                  <div
                    v-if="completedFirstPayment"
                    class="leading-none"
                  >
                    Membership expired
                  </div>
                  <div
                    v-if="!completedFirstPayment"
                    class="leading-none"
                  >
                    No membership
                  </div>
                </div>
              </div>
            </div>
          </MenuTooltip>
        </div>
      </div>
      <div
        class="mb-16 pb-2"
      >
        <router-link
          v-if="isAuthenticated && !$isNine && completedFirstPayment && !someFormOfExperienceMembership"
          :to="{ name: 'MembershipPack' }"
          @click.native="setView('MembershipPack')"
        >
          <MenuItem
            :selected-view="selectedView"
            :view-name="'MembershipPack'"
            :arrow-position="'middle'"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="envelope"
                style="width: 1.1rem; height: 1.1rem"
                role="img"
                viewBox="0 0 512 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z"
              /></g></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    Membership Pack
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    All the information you need<br> to get started, in one place.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          v-if="isAuthenticated && !$isNine && completedFirstPayment"
          :to="{ name: 'trophyProgress' }"
          @click.native="setView('trophyProgress')"
        >
          <MenuItem
            :selected-view="selectedView"
            view-name="trophyProgress"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="trophy-alt"
                style="width: 1.1rem; height: 1.1rem"
                role="img"
                viewBox="0 0 576 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M231.1 187.3l-9.4 54.6a12 12 0 0 0 17.4 12.6l49-25.8 49 25.8a12 12 0 0 0 17.4-12.6l-9.4-54.6 39.6-38.6c7.1-6.9 3.2-19-6.4-20.5l-54.8-8L299 70.6a12 12 0 0 0-21.5 0L253 120.2l-54.8 8a12 12 0 0 0-6.7 20.5zM384 432H192c-35.3 0-64 20.7-64 56v12a12 12 0 0 0 12 12h296a12 12 0 0 0 12-12v-12c0-35.3-28.7-56-64-56z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M552.12 64H448V24a23.94 23.94 0 0 0-23.88-24H152a23.94 23.94 0 0 0-24 23.88V64H24A23.94 23.94 0 0 0 0 87.88V144c0 66.5 77.9 131.7 171.9 142.4C203.3 338.5 240 360 240 360v72h96v-72s36.7-21.5 68.1-73.6C498.4 275.6 576 210.3 576 144V88a23.94 23.94 0 0 0-23.88-24zM64 144v-16h64.2a359 359 0 0 0 12.8 86.2c-47.5-16.4-77-49.9-77-70.2zm320.7 4.7l-39.6 38.6 9.4 54.6a12 12 0 0 1-17.4 12.6l-49-25.8-49 25.8a12 12 0 0 1-17.4-12.6l9.4-54.6-39.6-38.6a12 12 0 0 1 6.7-20.5l54.8-8 24.5-49.6a12 12 0 0 1 21.5 0l24.5 49.6 54.8 8c9.6 1.5 13.5 13.6 6.4 20.5zM512 144c0 20.2-29.4 53.8-77 70.2a359 359 0 0 0 12.8-86.2H512z"
              /></g></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    Trophies
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    Make the most out of your membership<br> whilst competing against your buddies.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          v-if="isAuthenticated && !$isNine"
          :to="{ name: 'MoreBenefits' }"
          @click.native="setView('MoreBenefits')"
        >
          <MenuItem
            :selected-view="selectedView"
            :view-name="'MoreBenefits'"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="hand-holding-medical"
                style="width: 1.15rem; height: 1.15rem"
                role="img"
                viewBox="0 0 576 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M559.73,392.21l-135,99.52A104.8,104.8,0,0,1,363,512H16A16.11,16.11,0,0,1,0,496V400a16.11,16.11,0,0,1,16-16H71.37l46.5-37.74A117.7,117.7,0,0,1,192,320H352a32.07,32.07,0,0,1,31.62,37.38C381,373.15,366.22,384,350.23,384H272a16,16,0,0,0,0,32H392.59l119.67-88.18a40,40,0,1,1,47.47,64.37Z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M400,96v64a16,16,0,0,1-16,16H320v64a16,16,0,0,1-16,16H240a16,16,0,0,1-16-16V176H160a16,16,0,0,1-16-16V96a16,16,0,0,1,16-16h64V16A16,16,0,0,1,240,0h64a16,16,0,0,1,16,16V80h64A16,16,0,0,1,400,96Z"
              /></g></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    MoreBenefits
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    Enjoy all year round special offers,<br> savings and discounts.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          v-if="!club.hideNetwork && (!$isNine && !isAuthenticated || !completedFirstPayment)"
          :to="{ name: 'ExploreMatrix' }"
          @click.native="setView('ExploreMatrix')"
        >
          <MenuItem
            :selected-view="selectedView"
            view-name="ExploreMatrix"
            :arrow-position="!isAuthenticated ? 'top' : 'middle'"
            :override-position="!isAuthenticated ? 'mt-6' : 'mt-2'"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="table"
                class=" mx-auto"
                style="width: 1.15rem; height: 1.15rem"
                role="img"
                viewBox="0 0 512 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M288 160v96h160v-96zm0 256h160v-96H288zM64 256h160v-96H64zm0 160h160v-96H64z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M464 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zM224 416H64v-96h160zm0-160H64v-96h160zm224 160H288v-96h160zm0-160H288v-96h160z"
              /></g></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    Explore Matrices
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    See how far your points can go at<br>the many clubs in our network.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          v-if="!$isNine"
          :to="{ name: 'purchaseGiftCardHome' }"
          @click.native="setView('purchaseGiftCardHome')"
        >
          <MenuItem
            :selected-view="selectedView"
            view-name="purchaseGiftCardHome"
          >
            <template #svg>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="gift"
                class=" mx-auto"
                style="width: 1.15rem; height: 1.15rem"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <g class="fa-group">
                  <path
                    class="fa-secondary"
                    opacity="0.4"
                    fill="currentColor"
                    d="M224 320v160H64a32 32 0 0 1-32-32V320zm0-160H32a32 32 0 0 0-32 32v80a16 16 0 0 0 16 16h208zm256 0H288v128h208a16 16 0 0 0 16-16v-80a32 32 0 0 0-32-32zM288 480h160a32 32 0 0 0 32-32V320H288z"
                  />
                  <path
                    class="fa-primary"
                    fill="currentColor"
                    d="M224 480h64V320h-64zM359.54 32c-41.82 0-68.86 21.3-103.54 68.3-34.68-47-61.72-68.3-103.54-68.3C103.71 32 64 71.5 64 120a85.65 85.65 0 0 0 10.15 40h78.21a40 40 0 1 1 0-80c20 0 34.78 3.3 86.55 80H224v128h64V160h-15c51.67-76.5 66-80 86.55-80a40 40 0 1 1 0 80h78.31A86.86 86.86 0 0 0 448 120c0-48.5-39.71-88-88.46-88z"
                  />
                </g>
              </svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    Gift Cards & Vouchers
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    Treat someone you know to a <br> gift card, or treat yourself!
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          v-if="isAuthenticated && completedFirstPayment"
          :to="{ name: 'historicalBookings' }"
          @click.native="setView('historicalBookings')"
        >
          <MenuItem
            :selected-view="selectedView"
            override-position="mb-4"
            view-name="historicalBookings"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="history"
                style="width: 1.15rem; height: 1.15rem"
                role="img"
                viewBox="0 0 512 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M141.68 400.23a184 184 0 1 0-11.75-278.3l50.76 50.76c10.08 10.08 2.94 27.31-11.32 27.31H24a16 16 0 0 1-16-16V38.63c0-14.26 17.23-21.4 27.31-11.32l49.38 49.38A247.14 247.14 0 0 1 256 8c136.81 0 247.75 110.78 248 247.53S392.82 503.9 256.18 504a247 247 0 0 1-155.82-54.91 24 24 0 0 1-1.84-35.61l11.27-11.27a24 24 0 0 1 31.89-1.98z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M288 152v104.35L328.7 288a24 24 0 0 1 4.21 33.68l-9.82 12.62a24 24 0 0 1-33.68 4.21L224 287.65V152a24 24 0 0 1 24-24h16a24 24 0 0 1 24 24z"
              /></g></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    Your History
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    Your past bookings and purchases.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          v-if="isAuthenticated && completedFirstPayment"
          :to="{ name: 'subscriptionSubscription' }"
          @click.native="setView('subscriptionSubscription')"
        >
          <MenuItem
            :selected-view="selectedView"
            view-name="subscriptionSubscription"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="sync-alt"
                style="width: 1rem; height: 1rem"
                role="img"
                viewBox="0 0 512 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M8 454.06V320a24 24 0 0 1 24-24h134.06c21.38 0 32.09 25.85 17 41l-41.75 41.75A166.82 166.82 0 0 0 256.16 424c77.41-.07 144.31-53.14 162.78-126.85a12 12 0 0 1 11.65-9.15h57.31a12 12 0 0 1 11.81 14.18C478.07 417.08 377.19 504 256 504a247.14 247.14 0 0 1-171.31-68.69L49 471c-15.15 15.15-41 4.44-41-16.94z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M12.3 209.82C33.93 94.92 134.81 8 256 8a247.14 247.14 0 0 1 171.31 68.69L463 41c15.12-15.12 41-4.41 41 17v134a24 24 0 0 1-24 24H345.94c-21.38 0-32.09-25.85-17-41l41.75-41.75A166.8 166.8 0 0 0 255.85 88c-77.46.07-144.33 53.18-162.79 126.85A12 12 0 0 1 81.41 224H24.1a12 12 0 0 1-11.8-14.18z"
              /></g></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    Subscription
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    Manage your PlayMoreGolf <br>subscription and saved cards.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          v-if="isAuthenticated"
          :to="{ name: 'profile' }"
          @click.native="setView('profile')"
        >
          <MenuItem
            :selected-view="selectedView"
            view-name="profile"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="user-cog"
                style="width: 1.125rem; height: 1.125rem; margin-left: 4px;"
                role="img"
                viewBox="0 0 640 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M636.3 388.2l-25.8-14.9a117.31 117.31 0 0 0 0-42.6l25.8-14.9a7.24 7.24 0 0 0 3.3-8.5 150.07 150.07 0 0 0-33.2-57.4 7.29 7.29 0 0 0-9-1.4l-25.8 14.9a117.4 117.4 0 0 0-36.9-21.3v-29.8a7.28 7.28 0 0 0-5.7-7.1 150.88 150.88 0 0 0-66.2 0 7.28 7.28 0 0 0-5.7 7.1v29.8a117.4 117.4 0 0 0-36.9 21.3l-25.8-14.9a7.31 7.31 0 0 0-9 1.4 150.07 150.07 0 0 0-33.2 57.4 7.37 7.37 0 0 0 3.3 8.5l25.8 14.9a117.31 117.31 0 0 0 0 42.6l-25.8 14.9a7.24 7.24 0 0 0-3.3 8.5 150.82 150.82 0 0 0 33.2 57.4 7.29 7.29 0 0 0 9 1.4l25.8-14.9a117.4 117.4 0 0 0 36.9 21.3v29.8a7.28 7.28 0 0 0 5.7 7.1 150.88 150.88 0 0 0 66.2 0 7.28 7.28 0 0 0 5.7-7.1v-29.8a117.4 117.4 0 0 0 36.9-21.3l25.8 14.9a7.31 7.31 0 0 0 9-1.4 150.07 150.07 0 0 0 33.2-57.4 7.37 7.37 0 0 0-3.3-8.5zM496 400.5a48.5 48.5 0 1 1 48.5-48.5 48.55 48.55 0 0 1-48.5 48.5z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M425.2 491.7v-9.2c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6a39.23 39.23 0 0 1-48.5-7.3 182.34 182.34 0 0 1-40.2-69.6 39.11 39.11 0 0 1 17.9-45.7l7.9-4.6q-.15-3.9 0-7.8l-7.9-4.6a39.07 39.07 0 0 1-17.9-45.7c.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h352a47.94 47.94 0 0 0 27.2-8.5 39 39 0 0 1-2-11.8zM224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128z"
              /></g></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    Profile
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    Mange your profile and<br> view your booking history.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          :to="{ name: 'helpSupport' }"
          @click.native="setView('helpSupport')"
        >
          <MenuItem
            v-if="homeClubId !== 520 && homeClubId !== 521"
            id="helpSupport"
            :selected-view="selectedView"
            :view-name="'helpSupport'"
            :arrow-position="'middle'"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="mail-bulk"
                style="width: 1.1rem; height: 1.1rem"
                role="img"
                viewBox="0 0 576 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M288 256H32a32 32 0 0 0-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288a32 32 0 0 0-32-32zM160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm288-224v64h64v-64z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M544 160H224a32 32 0 0 0-32 32v32h96a64.09 64.09 0 0 1 63.71 57.82l.29-.22V416h192a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zm-32 128h-64v-64h64zm-64-160V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v192h96v-32a64.07 64.07 0 0 1 64-64z"
              /></g></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    Help &amp; Support
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    Have a question or need assistance?<br> We're here to help.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          v-if="!$isNine"
          :to="{ name: 'news' }"
          @click.native="setView('news')"
        >
          <MenuItem
            :selected-view="selectedView"
            :view-name="'news'"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="info-circle"
                style="width: 1.1rem; height: 1.1rem"
                role="img"
                viewBox="0 0 512 512"
              ><g class="fa-group"><path
                class="fa-secondary"
                fill="currentColor"
                d="M256 8C119 8 8 119.08 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 110a42 42 0 1 1-42 42 42 42 0 0 1 42-42zm56 254a12 12 0 0 1-12 12h-88a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h12v-64h-12a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h64a12 12 0 0 1 12 12v100h12a12 12 0 0 1 12 12z"
                opacity="0.4"
              /><path
                class="fa-primary"
                fill="currentColor"
                d="M256 202a42 42 0 1 0-42-42 42 42 0 0 0 42 42zm44 134h-12V236a12 12 0 0 0-12-12h-64a12 12 0 0 0-12 12v24a12 12 0 0 0 12 12h12v64h-12a12 12 0 0 0-12 12v24a12 12 0 0 0 12 12h88a12 12 0 0 0 12-12v-24a12 12 0 0 0-12-12z"
              /></g></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    News &amp; Updates
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    Stay up-to-date with<br> all things PlayMoreGolf.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>

        <router-link
          :to="{ name: 'settingsHome' }"
          @click.native="setView('settingsHome')"
        >
          <MenuItem
            :selected-view="selectedView"
            :view-name="'settingsHome'"
            :arrow-position="'bottom'"
          >
            <template #svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="cogs"
                style="height: 1.1rem; width: 1.1rem;"
                role="img"
                viewBox="0 0 640 512"
              ><path
                fill="currentColor"
                d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
              /></svg>
            </template>
            <template #tooltip>
              <div class="flex items-center justify-center bg-gradient-to-br from-brand-200 to-brand-500 py-8 text-center text-white">
                <div>
                  <div class="brand-heading text-sm">
                    Settings
                  </div>
                  <div class="brand-body mt-2 text-xs">
                    Tweak the platform to suit<br> your preferences.
                  </div>
                </div>
              </div>
            </template>
          </MenuItem>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MenuItem from './menuItem.vue';
import MenuTooltip from './menuTooltip.vue';

export default {

  components: {
    MenuItem,
    MenuTooltip,
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedView: '',
      logoLoaded: false,
      isHoveringUserInfo: false,
      protectView: false,

      pointsRefreshing: false,
    };
  },

  computed: {
    ...mapState({
      logoUrl: state => state.club.logoUrl,
      tier: state => state.user.tier,
      homePoints: state => state.user.homePoints,
      flexiPoints: state => state.user.flexiPoints,
      lessonPoints: state => state.user.lessonPoints,
      forename: state => state.user.forename,
      surname: state => state.user.surname,
      membershipExpires: state => state.user.membershipExpires,
      isExpired: state => state.user.IsExpired,
      isAuthenticated: state => state.user.isAuthenticated,
      expiringSoon: state => state.user.expiringSoon,
      completedFirstPayment: state => state.user.completedFirstPayment,
      homeClubId: state => state.user.homeClubId,
      someFormOfExperienceMembership: state => state.user.someFormOfExperienceMembership,
      shouldBeMigratedToNine: state => state.user.shouldBeMigratedToNine,
    }),

    ...mapGetters({
      currentTheme: 'getCurrentTheme',
      club: 'getClub',
      lessonsEnabled: 'lessonsEnabled',
    }),
  },

  watch: {
    $route(to) {
      this.selectedView = to.name;
      if (!this.protectView) {
        this.selectedView = '';
      } else {
        this.protectView = false;
      }
    },

    async isHoveringUserInfo() {
      if (this.isHoveringUserInfo && !this.pointsRefreshing) {
        this.pointsRefreshing = true;
        await this.$store.dispatch('populateMemberSummary');
        this.pointsRefreshing = false;
      }
    },

    open() {
      if (this.open) {
        this.$store.dispatch('populateMemberSummary');
      }
    },
  },

  mounted() {
    this.selectedView = this.$route.name;
  },

  methods: {
    hideTour() {
      if (this.$tours.welcomeTour.currentStep === 1) {
        const element = document.getElementsByClassName('v-step')[0];
        if (element !== undefined) {
          element.classList = 'v-step opacity-0';
        }
      }
    },

    showTour() {
      const element = document.getElementsByClassName('v-step')[0];
      if (element !== undefined) {
        element.classList = 'v-step opacity-100';
      }
    },

    setView(view) {
      this.selectedView = view;
      this.protectView = true;
    },
  },
};


</script>

<style>
.sideBG {
  background-color: #22465C;
}

.menuItemBg {
  background-color: rgba(112, 123, 129, 0.286)
}

.pointsBG:hover {
  background-color: rgba(112, 123, 129, 0.286)
}

.menuItem {
  width: 5.2rem;
  height: 4rem;
}
</style>
